import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Ihr Partner in Sachen Sauberkeit",
    text: "Herzlich willkommen bei S&P Reinigungsservice — Ihrem Experten für Glas- und Gebäudereinigung in Esterwegen. Wir kümmern uns um alle Bereiche, die eine gründliche, professionelle Reinigung erfordern.",
  },
  {
    n: "02",
    title: "Kompetent & zuverlässig",
    text: "Vom einzelnen Fenster bis zur kompletten Bauendreinigung: Wir arbeiten präzise, termintreu und mit modernem Equipment — damit Sie sich um nichts kümmern müssen.",
  },
  {
    n: "03",
    title: "Faire Preise, starke Leistung",
    text: "Maßgeschneiderte Lösungen zu kostengünstigen Konditionen. Sie erhalten ein transparentes Angebot und ein Ergebnis, das für sich glänzt.",
  },
];

export default function Manifesto() {
  return (
    <section id="ueber-uns" className="relative bg-[#030712] py-28 md:py-40">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-8">
          {/* Left: image clipped */}
          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="relative overflow-hidden rounded-sm lg:sticky lg:top-28"
            >
              <img
                src="https://images.pexels.com/photos/34517611/pexels-photo-34517611.jpeg"
                alt="Professionelle Fassadenreinigung in der Höhe"
                className="w-full h-[420px] lg:h-[560px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#030712] via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 font-mono text-xs uppercase tracking-[0.2em] text-cyan-glass">
                Präzision in der Höhe
              </div>
            </motion.div>
          </div>

          {/* Right: chapters */}
          <div className="lg:col-span-7 lg:pl-10">
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="font-mono text-xs uppercase tracking-[0.3em] text-white/40 mb-12"
            >
              Über uns
            </motion.p>
            <div className="space-y-14">
              {chapters.map((c) => (
                <motion.div
                  key={c.n}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                  className="flex gap-6 md:gap-10 border-b border-white/10 pb-12"
                >
                  <span className="font-mono text-sm text-cyan-glass pt-2 shrink-0">{c.n}</span>
                  <div>
                    <h3 className="font-heading text-2xl md:text-4xl font-medium tracking-tight text-white mb-4">
                      {c.title}
                    </h3>
                    <p className="text-base md:text-lg font-light leading-relaxed text-white/60 max-w-xl">
                      {c.text}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
